import { render, staticRenderFns } from "./SubPoli.vue?vue&type=template&id=28a4c52a"
import script from "./SubPoli.vue?vue&type=script&lang=js"
export * from "./SubPoli.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports